import * as React from 'react';
import { FC } from 'react';

import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Modal from 'components/modal';
import { Box } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

import { Body, Header, ItemText, StyledPicture } from './modal-item-unavailable.styled';
import { IModalItemUnavailableViewProps } from './types';

export const ModalItemUnavailableView: FC<React.PropsWithChildren<
  IModalItemUnavailableViewProps
>> = ({
  handleContinue,
  handleChangeStore,
  unavailableItemName,
  header,
  image,
  selectNewBtnText,
  continueBtnText,
  body,
  imageAlt,
  hideSelectNewBtn,
}) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Modal
      amplitudeEventData={{
        modalAppearanceEventMessage: 'Static menu item unavailable',
      }}
      testID="item-unavailable-static-menu"
      allowsDismiss={false}
    >
      <Header fontSize={isDesktop ? '4xl' : '3xl'}>{header}</Header>
      <Body>{body}</Body>
      <StyledPicture alt={imageAlt} image={image} />
      <ItemText fontSize={isDesktop ? 'xl' : 'md'}>{unavailableItemName}</ItemText>
      <Box style={styles.actions}>
        <Box style={styles.primaryAction}>
          <ActionButton fullWidth onPress={handleContinue}>
            {continueBtnText}
          </ActionButton>
        </Box>
        {!hideSelectNewBtn && (
          <Box style={styles.secondaryAction}>
            <ActionButton
              fullWidth
              variant={ActionButtonVariants.OUTLINE}
              onPress={handleChangeStore}
            >
              {selectNewBtnText}
            </ActionButton>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

const styles = StyleSheet.create({
  actions: {
    flexDirection: 'column',
    marginTop: 32,
  },
  primaryAction: {
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 16,
    width: '100%',
  },
  secondaryAction: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
});
